export const SCORE_START_EVENT = 'comments_engagement_score_started'
export const SCORE_STOP_EVENT = 'comments_engagement_score_stopped'

export const SESSION_SCORE_KEY_PREFIX = 'comments_session_score_at_start'
export const SESSION_SCORE_TIMESTAMP_KEY_PREFIX =
  'comments_session_score_started_at'

export const THRESHOLD_FOR_SCORE_INCREASE = 10
export const MAX_SESSION_AGE_MS = 60 * 60 * 1000 // 1 hour
